/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( document ).on( 'click', '.filters-list button', function() {
        removeFilter( $( this ).attr( 'data-filter' ) );
        toggleClearButton();
      } );

      $( document ).on( 'change', 'input', function() {
        const filterId = $( this ).attr( 'id' );

        if ( $( this ).prop( 'checked' ) ) {
          const filterName = $( this ).next().text().trim();

          $( '.filters-list' ).append( `<li>${filterName} <button title="Remove filter for ${filterName}" data-filter="#${filterId}"><svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg></button></li>` );
        } else {
          $( '.filters-list button[data-filter="#' + filterId + '"]' ).closest( 'li' ).remove();
        }

        toggleClearButton();

        filterEvents( 1 );
      } );

      $( document ).on( 'click', '.pagination button', function() {
        filterEvents( $( this ).attr( 'data-value' ) );
      } );

      $( document ).on( 'click', '.clear-filters', function() {
        $( '.filters-list li' ).each( function( key, filter ) {
          removeFilter( $( filter ).find( 'button' ).attr( 'data-filter' ) );
        } );

        toggleClearButton();
      } );

      function toggleClearButton() {
        if ( $( '.filters-list li' ).length == 0 ) {
          $( '.filters-list' ).next().addClass( 'hidden' );
        } else {
          $( '.filters-list' ).next().removeClass( 'hidden' );
        }
      }

      function removeFilter( filterId ) {
        $( filterId ).prop( 'checked', false ).trigger( 'change' );
        $( '.filters-list button[data-filter="' + filterId + '"]' ).closest( 'li' ).remove();
      }

      function filterEvents( page ) {
        $( '.event-results__area' ).addClass( 'is-loading' );

        const type = [];
        const day = [];
        const month = [];
        const cost = [];
        const format = [];
        const location = [];

        $( 'input[name="event-type"]:checked' ).each( function() {
          type.push( $( this ).val() );
        } );

        $( 'input[name="event-day"]:checked' ).each( function() {
          day.push( $( this ).val() );
        } );

        $( 'input[name="event-month"]:checked' ).each( function() {
          month.push( $( this ).val() );
        } );

        $( 'input[name="event-cost"]:checked' ).each( function() {
          cost.push( $( this ).val() );
        } );

        $( 'input[name="event-format"]:checked' ).each( function() {
          format.push( $( this ).val() );
        } );

        $( 'input[name="event-location"]:checked' ).each( function() {
          location.push( $( this ).val() );
        } );

        const data = {
          'page': page,
          'type': type,
          'day': day,
          'month': month,
          'cost': cost,
          'format': format,
          'location': location,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/filter', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            console.log( data );
            $( '.event-results__area' ).html( data.results );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
            $( '.event-results__area' ).removeClass( 'is-loading' );
          },
          error: function( request, status, error ) {
            console.log( request.responseText );
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'events', COMPONENT );
} )( app );
